/// <reference path='references.ts' />

class Utils {

    public static translate(key: string, args?: string[], defaultValue?: string): string {
        let translation = translations[key];
        let result;
        if(translation) {
            result = translation;
        }
        else if(defaultValue) {
            result = defaultValue;
        }
        else if($('html').data('lang-js') === 'en') {
            result = '**' + key + '**';
        }
        else {
            result = key;
        }
        if(args) {
            $.each(args, function(i, arg){
                result = result.replace('{' + i + '}', arg);
            });
        }
        if(!translation) {
            log('Missing translation (' + $('html').data('lang-js') + '): ' + key);
        }
        return result;
    }

    /**
     * Log a message to console checking it exists first
     * @param msg - The msg to output
     */
    public static log(msg: string): void {
        if(window.console && console.log) {
            // noinspection TsLint
            console.log(msg);
        }

    }

    public static hasFormValidation(): boolean {

        if($(document).data('hasFormValidation') === undefined) {
            $(document).data('hasFormValidation', (typeof document.createElement( 'input' ).checkValidity === 'function'));
        }
        return $(document).data('hasFormValidation');
    }

    public static url(path: string): string {
        return '/fpm' + path;
    }

    public static staticUrl(path: string): string {
        return url('/static/4f5b5ca' + path);
    }

    public static staticImageUrl(path: string): string {
        return staticUrl('/images' + path);
    }

    public static staticJavaScriptUrl(path: string): string {
        return staticUrl('/js' + path);
    }

    public static staticCssUrl(path: string): string {
        return staticUrl('/css' + path);
    }

    public static escape(myid: string): string {
        return myid.replace( /(:|\.|\[|\]|,|')/g, '\\$1' );
    }

    public static htmlDecode(text: string): string {
        return text.replace(/\&quot;/g, '"')
            .replace(/\&#39;/g, '\'')
            .replace(/\&lt;/g, '<')
            .replace(/\&gt;/g, '>')
            .replace(/\&amp;/g, '&');
    }

    public static formatFileSize(bytes: number): string {
        if (bytes >= 1048576) {
            let megabytes = bytes / 1048576;
            return megabytes.toFixed(1) + 'MB';
        } else if (bytes >= 1024) {
            let kilobytes = bytes / 1024;
            return kilobytes.toFixed(1) + 'KB';
        } else {
            return bytes + 'B';
        }
    }
}

let translations = {};

// top level functions for backwards compat.
// noinspection TsLint
let translate = Utils.translate;
let log = Utils.log;
// noinspection TsLint
let hasFormValidation = Utils.hasFormValidation;
let url = Utils.url;
let staticUrl = Utils.staticUrl;
// noinspection TsLint
let staticImageUrl = Utils.staticImageUrl;
// noinspection TsLint
let staticJavaScriptUrl = Utils.staticJavaScriptUrl;
// noinspection TsLint
let staticCssUrl = Utils.staticCssUrl;
// noinspection TsLint
let escape = Utils.escape;
